"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Description;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var s = {
  subTitle: function subTitle(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:10px;font-weight:500;letter-spacing:1.83px;color:", theme.color.dark.iron, ";margin-top:", isMobile ? '0px' : '8px', ";")
    );
  }
};

function Description(props) {
  var subTitle = props.subTitle,
      theme = props.theme,
      isMobile = props.isMobile,
      customClassName = props.customClassName;

  if (!subTitle) {
    return null;
  }

  return _react.default.createElement("div", {
    title: subTitle,
    className: (0, _classnames.default)(s.subTitle(theme, isMobile), customClassName)
  }, subTitle);
}